import React from "react";
import { MapPin, BadgeCheck } from "lucide-react";
import { Btn } from "./ui";
import { LINKS } from "./data";

const HERO_IMG =
  "https://images.pexels.com/photos/2680013/pexels-photo-2680013.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1100";

export const Hero = () => (
  <section id="home" className="pt-[70px]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-10">
      <div className="bg-[#F5F5F5] rounded-[20px] overflow-hidden">
        <div className="grid lg:grid-cols-2 items-center">
          <div className="p-8 sm:p-12 lg:p-16">
            <p className="fade-up-1 text-[#C9A961] font-heading font-bold uppercase tracking-[0.18em] text-xs mb-5">
              Southern California Real Estate
            </p>
            <h1 className="fade-up-2 font-heading font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#2D2D37]">
              Find Your Next Home With a Brokerage Built Around You
            </h1>
            <p className="fade-up-3 mt-6 text-base sm:text-lg leading-relaxed text-[#2D2D37]/70 max-w-xl">
              Search Southern California homes, connect with a local buyer agent, and get real
              estate and mortgage guidance from Wallstreet Realty.
            </p>
            <p className="fade-up-3 mt-4 text-sm text-[#2D2D37]/55 font-medium">
              Serving buyers, sellers, and licensed agents across Southern California.
            </p>
            <div className="fade-up-4 mt-8 flex flex-wrap gap-3">
              <Btn href={LINKS.idx} variant="primary" testid="hero-search-homes" pill>
                Search Homes
              </Btn>
              <Btn href={LINKS.buyers} variant="gold" testid="hero-talk-buyer-agent">
                Talk to a Buyer Agent
              </Btn>
              <Btn href={LINKS.join} variant="outline" testid="hero-join">
                Join Wallstreet Realty
              </Btn>
            </div>
          </div>
          <div className="p-6 sm:p-8 lg:p-10">
            <div className="relative animate-float-slow">
              <img
                src={HERO_IMG}
                alt="Southern California luxury home exterior"
                className="w-full h-[280px] sm:h-[380px] lg:h-[460px] object-cover rounded-[20px] shadow-lg"
                loading="eager"
              />
              {/* Floating trust chips */}
              <div className="hidden sm:flex items-center gap-2 absolute -bottom-4 left-4 bg-white rounded-xl shadow-lg px-4 py-3 animate-float">
                <MapPin size={18} className="text-[#C9A961]" />
                <span className="text-sm font-medium text-[#2D2D37]">Serving Southern California</span>
              </div>
              <div className="hidden sm:flex items-center gap-2 absolute -top-4 right-4 bg-[#254369] rounded-xl shadow-lg px-4 py-3 animate-float" style={{ animationDelay: "1.2s" }}>
                <BadgeCheck size={18} className="text-[#C9A961]" />
                <span className="text-sm font-medium text-white">DRE #01926616</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
